import React, { useEffect, useState } from 'react';
import { Play, VideoOff } from 'react-feather';
import { useGlobalState } from 'state-pool';
import { Button, Tooltip } from 'reactstrap';

export const VideoAnimationToggle = () => {
  const [state, setState] = useGlobalState('animateVideo');
  const [basictooltip, setbasictooltip] = useState(false);
  const toggle = () => setbasictooltip(!basictooltip);

  useEffect(() => {
    const persistent = JSON.parse(window.localStorage.getItem('animateVideo'));

    if (persistent === null) {
      window.localStorage.setItem('animateVideo', JSON.stringify(true));
      setState(true);
    } else {
      setState(persistent);
    }
  }, [setState, state]);

  // TODO: Detect FPS drop and recomend disabeling animation
  // useEffect(() => {
  //   setTimeout(() => {
  //     let before, now, fps;

  //     before = Date.now();
  //     fps = 0;

  //     requestAnimationFrame(function loop() {
  //       now = Date.now();
  //       fps = Math.round(1000 / (now - before));
  //       before = now;

  //       if (fps < 20) {
  //         setbasictooltip(true);
  //       }
  //       //console.log(fps);
  //       requestAnimationFrame(loop);
  //     });
  //   }, 1000);

  //   return () => clearTimeout();
  // }, []);

  return (
    <div>
      <Button
        id='video-toggle'
        color='link'
        size='small'
        className='video-toggle-btn'
        onClick={() => {
          setState(!state);
          window.localStorage.setItem('animateVideo', JSON.stringify(!state));
        }}
      >
        {state ? <VideoOff /> : <Play />}
      </Button>
      <Tooltip placement='bottom' isOpen={basictooltip} target='video-toggle' toggle={toggle}>
        {state ? 'Disable videos to increase performance' : 'Enable videos, it might decrease performance'}
      </Tooltip>
    </div>
  );
};
